import { makeStyles } from "@material-ui/core/styles";
import themeColorsDesingSystem from "assets/theme/ds-colors";

export default makeStyles({
  pageContent: {
    marginTop: "-4.5rem",
    paddingBottom: 32,
  },
  headerCard: {
    borderRadius: 12,
    marginBottom: 24,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#fff",
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
    },
  },
  filterButton: {
    height: 48,
    borderRadius: 8,
    whiteSpace: "nowrap",
  },
  heroRoot: {
    position: "relative",
    borderRadius: 12,
    overflow: "hidden",
    marginBottom: 40,
    height: 300,
    backgroundColor: themeColorsDesingSystem.stone.light,
  },
  heroSlide: {
    position: "absolute",
    inset: 0,
    opacity: 0,
    transition: "opacity 0.7s ease-in-out",
    pointerEvents: "none",
  },
  heroSlideActive: {
    opacity: 1,
    pointerEvents: "auto",
  },
  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  heroOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "32px 86px",
    background:
      "linear-gradient(90deg, rgba(19,41,75,0.82) 0%, rgba(19,41,75,0.35) 55%, transparent 100%)",
  },
  heroNavBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: "rgba(255,255,255,0.92)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    zIndex: 2,
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  heroDots: {
    position: "absolute",
    bottom: 16,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    gap: 8,
    zIndex: 2,
  },
  heroDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    cursor: "pointer",
    transition: "transform 0.2s ease, background-color 0.2s ease",
  },
  section: {
    marginBottom: 40,
  },
  categoryChip: {
    borderRadius: 20,
    fontWeight: 500,
    height: 36,
  },
  contentCard: {
    borderRadius: 12,
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    overflow: "hidden",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    transition: "box-shadow 0.2s ease",
    "&:hover": {
      boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
    },
  },
  cardMedia: {
    height: 180,
    objectFit: "cover",
    cursor: "pointer",
  },
  cardMediaCompact: {
    height: 160,
  },
  cardFooter: {
    padding: "14px 16px",
    borderTop: `1px solid ${themeColorsDesingSystem.stone.light}`,
    flex: 1,
  },
  cardActions: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    marginLeft: 8,
    flexShrink: 0,
  },
  videoScroll: {
    display: "flex",
    gap: 20,
    overflowX: "auto",
    paddingBottom: 8,
    scrollSnapType: "x mandatory",
    "& > *": {
      scrollSnapAlign: "start",
      flex: "0 0 280px",
      maxWidth: 280,
    },
  },
  fileCard: {
    borderRadius: 12,
    border: `1px solid ${themeColorsDesingSystem.stone.main}`,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    padding: 16,
    display: "flex",
    alignItems: "center",
    height: "100%",
    backgroundColor: "#fff",
    cursor: "pointer",
    transition: "box-shadow 0.2s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    },
  },
  emptyState: {
    backgroundColor: themeColorsDesingSystem.stone.light,
    borderRadius: 12,
    border: `1px dashed ${themeColorsDesingSystem.stone.medium}`,
    padding: 32,
    textAlign: "center",
  },
});
